import { TimeOffCategoryPolicySchema } from "@/pages/settings/time-off/policy/TimeOffCategoryPolicyEdit.tsx";
import { ApiTimeOffPolicyMilestoneTransferType } from "@/types/time-off/time-off-policy.types.ts";
import { Box, Radio, Stack, Title } from "@skailer-com/uikit";
import { Controller, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface TimeOffPolicyMilestoneTransferProps {
  formHook: UseFormReturn<TimeOffCategoryPolicySchema>;
}

export function TimeOffPolicyMilestoneTransfer({ formHook }: TimeOffPolicyMilestoneTransferProps) {
  const { t } = useTranslation();
  const { control, watch } = formHook;

  const milestones = watch("milestones");

  if (milestones && milestones.length <= 1) {
    return null;
  }

  return (
    <Stack>
      <Title
        header={t("time_off:milestone_transfer_type_title")}
        caption={t("time_off:milestone_transfer_type_description")}
        size={"xs"}
        paddingBottom
      />
      <Box variant={"border"}>
        <Controller
          render={({ field: { value, onChange } }) => (
            <>
              <Radio
                value={ApiTimeOffPolicyMilestoneTransferType.immediately_on_condition}
                checked={value == ApiTimeOffPolicyMilestoneTransferType.immediately_on_condition}
                onChange={() => {
                  onChange(ApiTimeOffPolicyMilestoneTransferType.immediately_on_condition);
                }}
                title={t("time_off:milestone_transfer_type_immediately_title")}
                caption={t("time_off:milestone_transfer_type_immediately_caption")}
              />
              <Radio
                value={ApiTimeOffPolicyMilestoneTransferType.end_of_accrual_period}
                checked={value == ApiTimeOffPolicyMilestoneTransferType.end_of_accrual_period}
                onChange={() => {
                  onChange(ApiTimeOffPolicyMilestoneTransferType.end_of_accrual_period);
                }}
                title={t("time_off:milestone_transfer_type_end_period_title")}
                caption={t("time_off:milestone_transfer_type_end_period_caption")}
              />
            </>
          )}
          control={control}
          name={"milestone_transfer_type"}
        />
      </Box>
    </Stack>
  );
}
